const state = {
  userInfo: null,
  token: localStorage.getItem('token') || '',
  permissions: [],
  userAvatar: localStorage.getItem('userAvatar') || null, // 全局头像状态
  userNickName: localStorage.getItem('userNickName') || null, // 全局昵称状态
  userId: localStorage.getItem('userId') || null, // 全局用户ID状态
  memberInfo: JSON.parse(localStorage.getItem('memberInfo') || 'null') // 全局会员状态
}

const mutations = {
  SET_USER_INFO (state, userInfo) {
    state.userInfo = userInfo
  },
  SET_TOKEN (state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_PERMISSIONS (state, permissions) {
    state.permissions = permissions
  },
  SET_USER_AVATAR (state, avatarUrl) {
    state.userAvatar = avatarUrl
    localStorage.setItem('userAvatar', avatarUrl)
  },
  SET_USER_NICKNAME (state, nickName) {
    state.userNickName = nickName
    localStorage.setItem('userNickName', nickName)
  },
  SET_USER_ID (state, userId) {
    state.userId = userId
    localStorage.setItem('userId', userId)
  },
  SET_MEMBER_INFO (state, memberInfo) {
    state.memberInfo = memberInfo
    localStorage.setItem('memberInfo', JSON.stringify(memberInfo))
  },
  CLEAR_USER_DATA (state) {
    state.userInfo = null
    state.token = ''
    state.permissions = []
    state.userAvatar = null
    state.userNickName = null
    state.userId = null
    state.memberInfo = null
    localStorage.removeItem('token')
    localStorage.removeItem('userAvatar')
    localStorage.removeItem('userNickName')
    localStorage.removeItem('userId')
    localStorage.removeItem('memberInfo')
  }
}

const actions = {
  login ({ commit }, { token, userInfo }) {
    commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo)
  },
  logout ({ commit }) {
    commit('CLEAR_USER_DATA')
  },
  setPermissions ({ commit }, permissions) {
    commit('SET_PERMISSIONS', permissions)
  },
  updateUserAvatar ({ commit }, avatarUrl) {
    commit('SET_USER_AVATAR', avatarUrl)
  },
  updateUserNickName ({ commit }, nickName) {
    commit('SET_USER_NICKNAME', nickName)
  },
  updateUserId ({ commit }, userId) {
    commit('SET_USER_ID', userId)
  },
  updateMemberInfo ({ commit }, memberInfo) {
    commit('SET_MEMBER_INFO', memberInfo)
  }
}

const getters = {
  isLoggedIn: state => !!state.token,
  userInfo: state => state.userInfo,
  token: state => state.token,
  permissions: state => state.permissions,
  userAvatar: state => state.userAvatar || require('@/assets/images/g_01.jpg'),
  userNickName: state => state.userNickName || '东京街角1号',
  userId: state => state.userId || 'USRID405031',
  memberInfo: state => state.memberInfo || {
    levelName: '个人VIP',
    expireTime: '2026.07.09',
    availabeCount: 0,
    availabeTime: 0
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
